
import { buildStorageUrl } from '@/integrations/supabase/urlBuilder';

export const getStorageUrlWithCacheBuster = (publicUrl: string): string => {
  // Добавляем cache-buster параметр для обхода кэша браузера
  const timestamp = Date.now();
  const separator = publicUrl.includes('?') ? '&' : '?';
  return `${publicUrl}${separator}t=${timestamp}`;
};

export const buildStorageUrlWithCacheBuster = (bucket: string, path: string): string => {
  const baseUrl = buildStorageUrl(bucket, path);
  return getStorageUrlWithCacheBuster(baseUrl);
};

// Добавляем функцию getStorageUrl для обратной совместимости
export const getStorageUrl = (url: string): string => {
  return getStorageUrlWithCacheBuster(url);
};
